import { useNuxtApp } from "#app";
export default function useLogtoClient() {
  const nuxtApp = useNuxtApp();
  const client = nuxtApp.ssrContext?.event.context.logtoClient;
  return client;
}
